import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type {
  IDispAgendas,
  IDispHoras
} from '@/modules/Agendamiento/interfaces/IDisponibilidad'
import type { IConfContratosxservicios } from '@/modules/Contratacion/interfaces'
export class DisponibilidadService extends BaseService<Record<string, unknown>> {
  constructor () {
    super({
      baseUrl: 'scheduling/availability/'
    })
  }
  async getAgendas (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<IDispAgendas[]>>> {
    return this.http
      .get<IResponseApi<IDispAgendas[]>>(`/schedules`, { params })
      .catch(this.errorHandle)
  }
  async getHoras (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<IDispHoras[]>>> {
    return this.http
      .get<IResponseApi<IDispHoras[]>>(`/hours`, { params })
      .catch(this.errorHandle)
  }
  async getServicios (
    id: number,
    params: Record<string,unknown>
  ): Promise<AxiosResponse<IResponseApi<IConfContratosxservicios[]>>> {
    return this.http
      .get<IResponseApi<IConfContratosxservicios[]>>(`/services/${id}`,{params})
      .catch(this.errorHandle)
  }
}
